import { OurWorkType } from "@/@types/types";
import React from "react";
import { Helmet } from "react-helmet";
import { Layout } from "../Layout";
import SEO, { SEOType } from "../SEO";
import { Breadcrumb } from "../Shared/Breadcrumb";
import { PortfolioFilters } from "./portfolio-filters";
import { PortfolioHero } from "./portfolio-hero";
import { PortfolioProjectCard } from "./portfolio-project-card";
import * as styles from "./portfolio.module.css";

interface PortfolioProps {
  works: OurWorkType[];
  seo: SEOType;
  stats?: string[];
  liveTrackingText?: string;
}

interface PortfolioState {
  activeFilter: string;
  categories: string[];
}

export class Portfolio extends React.Component<PortfolioProps, PortfolioState> {
  private filters: string[] = [
    "All Projects",
    "Healthcare",
    "Communication",
    "Fintech",
    "Entertainment",
  ];

  constructor(props: PortfolioProps) {
    super(props);
    this.state = {
      activeFilter: "All Projects",
      categories: this.collectCategories(props.works),
    };
  }

  collectCategories(works: OurWorkType[]): string[] {
    const cats = new Set<string>();
    works.forEach((w) => {
      if (w.category) {
        cats.add(w.category);
      }
    });
    return ["All Projects", ...Array.from(cats)];
  }

  handleFilterChange = (filter: string): void => {
    this.setState({ activeFilter: filter });
  };

  render(): JSX.Element {
    const { works, seo, stats, liveTrackingText } = this.props;
    const { activeFilter } = this.state;

    const filteredWorks =
      activeFilter === "All Projects"
        ? works
        : works.filter((w) => (w.category || "").toLowerCase() === activeFilter.toLowerCase());
    const filters = this.state.categories.length ? this.state.categories : this.filters;

    return (
      <Layout>
        <Helmet>
          {/* <link
            href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Outfit:wght@400;600;700&display=swap"
            rel="stylesheet"
          /> */}
          <style>
            {`
              .portfolio-breadcrumb .cover {
                position: relative;
                min-height: 270px;
              }
              .portfolio-breadcrumb .cover::after {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-image: url(/images/logo-white.png);
                background-size: 300px auto;
                background-repeat: no-repeat;
                background-position: center;
                opacity: 0.15;
                z-index: 1;
                pointer-events: none;
              }
              .portfolio-breadcrumb .page-top {
                position: relative;
                z-index: 2;
              }
            `}
          </style>
        </Helmet>
        <SEO contentfulSeo={seo} />
        <div className="portfolio-breadcrumb">
          <Breadcrumb
            currentPageTitle="Our Portfolio"
            routes={[
              { path: "/", title: "Home" },
              { path: "/our-work/", title: "Portfolio", baseUrlOff: true },
            ]}
          />
        </div>
        <div className={styles.portfolioContainer}>
          <main>
            <PortfolioHero stats={stats} liveTrackingText={liveTrackingText} />

            <section className="pb-5">
              <div className="container">
                <PortfolioFilters
                  filters={filters}
                  activeFilter={activeFilter}
                  onFilterChange={this.handleFilterChange}
                />

                <div className="row">
                  {filteredWorks.map((work) => (
                    <PortfolioProjectCard key={work.id || work.title} work={work} />
                  ))}
                </div>
              </div>
            </section>
          </main>
        </div>
      </Layout>
    );
  }
}
